export default [
    {
        path: '/agent-messages',
        props: true,
        component: () => import('@/views/Agent/Message'),
    },
];
